import React from 'react';
import ReactDOM from 'react-dom';

class ResultsHeader extends React.Component {
  constructor(props) {
    super(props);
    this._onTemplateChange = this._onTemplateChange.bind(this);
  }
  numberWithCommas(n) {
    var parts = n.toString().split('.');
    return (
      parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (parts[1] ? '.' + parts[1] : '')
    );
  }
  _onTemplateChange() {
    if (this.props.selectedResultLayout != event.target.value) {
      this.props.resultLayoutChange(event.target.value);
    }
  }
  render() {
    var listClass;
    var mapClass;
    const isCalendar = this.props.eventType == "calendarEvents";

    if (this.props.selectedResultLayout == "list") {
      listClass = "btn btn-sm btn-success col-12 me-2";
      mapClass= "btn btn-sm col-12 btn-primary";
    }
    else {
    listClass = "btn btn-sm col-12 btn-primary me-2";
      mapClass= "btn btn-sm btn-success col-12";
    }

    return (
      <div className="g-mb-30">
        <div className='row mb-2'>
          <div className='col-4'>
            <h6 className="text-uppercase g-mb-10 g-mb--lg">
              <span className="g-color-gray-dark-v1">{this.numberWithCommas(this.props.totalResults)}</span> results </h6>
          </div>
          <div className='col-3'>
            <div className="form-group">
              <label htmlFor="display-input">Display</label>
              {/* <div id="display-input" className="btn-group" onChange={this._onTemplateChange}> */}
              <div id="display-input" onChange={this._onTemplateChange}>
                <label className="u-check col-md-5 me-2 mb-1">
                  <input className="d-none" name="template" type="radio" value="list" defaultChecked={this.props.selectedResultLayout == "list"} />
                  <span className={listClass}>List</span>
                </label>
                <label className="u-check col-md-5">
                  <input className="d-none" name="template" type="radio" value="map" defaultChecked={this.props.selectedResultLayout == "map"} />
                  <span className={mapClass}>Map</span>
                </label>
              </div>
            </div>
          </div>
          <div className='col-5'>
            <div className="form-group">
              <label htmlFor="sortby-input">Sort By</label>
              <select id="sortby-input" className="pull-right  form-select form-select-sm" onChange={this.props.sortChange} value={this.props.sortValue} disabled={this.props.selectedResultLayout == "map"}>

                {isCalendar && (
                  <>
                    <option value="EVENT_DATE_ASC">Date Asc.</option>
                    <option value="EVENT_DATE_DESC">Date Desc.</option>
                  </>
                )}

                <option value="DISTANCE_ASC">Distance Asc.</option>
                <option value="DISTANCE_DESC">Distance Desc.</option>
                {!isCalendar && (
                  <>
                    <option value="COMPLETED_COUNT_ASC">Completed Count Asc.</option>
                    <option value="COMPLETED_COUNT_DESC">Completed Count Desc.</option>
                  </>
                )}
                <option value="DISTANCE_TO_YOU_ASC" disabled={!this.props.hasUserLocation}>Proximity To You Asc.</option>
                <option value="DISTANCE_TO_YOU_DESC" disabled={!this.props.hasUserLocation}>Proximity To You Desc.</option>
              </select>
            </div>
          </div >
        </div >
      </div >
    );
  }
}
export default ResultsHeader;